"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdGrid_1 = require("views/stdGrid");
const globals_1 = require("models/globals");
const menuButtons_1 = require("../models/menuButtons");
class ParametresGrid extends stdGrid_1.default {
    constructor(app, name) {
        super(app, name, {
            moduleName: "parametres",
            datatableName: "parametresdatatable",
            columns: [
                { id: "unid", header: (0, globals_1._)("N°"), width: 40, css: { "text-align": "right" }, sort: "int" },
                { id: "cle", editor: "text", header: (0, globals_1._)("Code"), width: 120, sort: "text", maxlength: 24 },
                { id: "designation", editor: "text", header: (0, globals_1._)("Description"), width: 600, sort: "text", maxlength: 100 },
                { id: "valeur", editor: "text", header: (0, globals_1._)("Valeur"), width: 140, maxlength: 14 },
                { id: "texte", editor: "text", header: (0, globals_1._)("Texte"), width: 400, fillspace: true }
            ],
            title: (0, globals_1._)("Paramètres de l'application"),
            boutons: [menuButtons_1.ajouterButton, menuButtons_1.supprimerButton],
            resizeColumn: true,
            urlData: globals_1.phpPath + "parametres.php?option=list",
            saveData: {
                updateFromResponse: true,
                "insert": globals_1.phpPath + "parametres.php?option=insertEmpty",
                "update": globals_1.phpPath + "parametres.php?option=update",
                "delete": globals_1.phpPath + "parametres.php?option=delete",
            },
            tname: "tname=parametres",
        });
    }
    dupliquer() {
        super.dupliquer("cle");
    }
    ready() {
        this.currentGrid = $$(this.datatableName);
        let me = this;
        let menu = this.$$("stdGridMenu");
        menu.attachEvent("onMenuItemClick", function (id, e, node) {
            switch (id) {
                case "button-add":
                    me.ajouter();
                    break;
                case "button-del":
                    me.supprimer();
                    break;
            }
        });
        if ((globals_1.lv2.droits).includes(this.moduleName + ".insertEmpty,")) {
            menu.showMenuItem("button-add");
        }
        if ((globals_1.lv2.droits).includes(this.moduleName + ".delete,")) {
            menu.showMenuItem("button-del");
        }
        this.searchField = $$("search");
        this.searchField.show();
        this.searchField.attachEvent("onTimedKeyPress", function () {
            //get user input value
            var value = this.getValue().toLowerCase();
            me.currentGrid.filter(function (obj) {
                if (obj.designation) {
                    let odescription = (obj.designation + " " + obj.texte).toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                    return odescription.toLowerCase().indexOf(value) != -1;
                }
                return 0;
            });
        });
    }
}
exports.default = ParametresGrid;
